import { BookCopy, Headset } from 'lucide-react';
import SupportCard from './SupportCard';

export default function SupportSection() {
  return (
    <div className="items-center justify-between gap-20 md:flex">
      <div className="">
        <h1 className="text-[42px] font-medium">Dedicated Support When You Need It</h1>
      </div>
      <div className="items-center gap-4 md:flex">
        <SupportCard
          icon={<Headset />}
          title="24/7 Support"
          description="Our support team is available on the clock to answer all inquiries, technical support and receive feedback "
        />
        <SupportCard
          icon={<BookCopy />}
          title="Comprehensive Help Center"
          description="Our comprehensive Help Center is your go-to source for a wealth of resources, expert guides, and FAQs"
        />
      </div>
    </div>
  );
}
